cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_storecheckquery_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
    init: function (viewmodel) {
      // ====== 处理盈亏类型的 ‘全部’ 选项 ======
      // viewmodel.on("beforeSearch", function (condition) {
      //   var common = condition.commonVOs;
      //
      //   if (common != undefined && common.length > 0) {
      //     var datas = [];
      //
      //     common.forEach(function (item) {
      //       if (!(item.itemName == "vType" && item.value1 == "-1")) {
      //         datas.push(item);
      //       }
      //     });
      //
      //     condition.commonVOs = datas;
      //     condition['isExtend'] = true;
      //   }
      // });

      viewmodel.on('afterInit', function () {
        var currentDate = new Date().format('yyyy-MM-dd');

        // viewmodel.get('vouchdate').getFromModel().setValue(getFirstDayOfCurrentMonth());
        // viewmodel.get('vouchdate').getToModel().setValue(currentDate);

        //门店过滤
        var curStoreId = cb.rest.AppContext.user.storeId;
        var userStores = cb.rest.AppContext.user.userStores;
        var defaultValue = {id:curStoreId};
        var currentStore = userStores && userStores.find(function(item){
          return item.store === curStoreId;
        });

        if (currentStore) {
          defaultValue.code = currentStore.store_code;
          defaultValue.name = currentStore.store_name;
        }

        if (viewmodel.get("store_name")) {
          if (cb.rest.AppContext.user.userType != 0) {
            viewmodel.get('store_name').getFromModel().setValue([defaultValue]);
          }
        }


        // viewmodel.get("store_name").getFromModel().on('beforeBrowse', function (data) {
        //   //只能参照到当前用户有权限的门店
        //   var userStores = cb.rest.AppContext.user.userStores;
        //   var store_ids = [];
        //   if (userStores != null && userStores != "" && userStores.length != 0) {
        //     for (var i = 0; i < userStores.length; i++) {
        //       store_ids.push(userStores[i].store);
        //     }
        //     var conditionStore = {
        //       "isExtend": true,
        //       simpleVOs: []
        //     };
        //
        //     conditionStore.simpleVOs.push({
        //       field: 'id',
        //       op: 'in',
        //       value1: store_ids
        //     });
        //
        //     viewmodel.get('store_name').getFromModel().setFilter(conditionStore);
        //   } else {
        //     cb.utils.alert("无门店权限！", 'error');
        //     return false;
        //   }
        // });

        //门店变化以后清空仓库
        if (viewmodel.get("store_name")) {
          viewmodel.get("store_name").getFromModel().on('afterValueChange', function (data) {
            viewmodel.get('warehouse_name').getFromModel().setValue(null);
          });
        }

        //选择仓库之前，如果选择门店，按照门店过滤,否则根据当前用户有权限的门店进行过滤
        viewmodel.get("warehouse_name").getFromModel().on('beforeBrowse', function (data) {
          var promise = new cb.promise();
          var store_ids = [];

          if (viewmodel.get("store_name")
            && viewmodel.get("store_name").getData().value1 != null
            && viewmodel.get("store_name").getData().value1 != ""
            && viewmodel.get("store_name").getData().value1.length != 0) {

            store_ids = viewmodel.get("store_name").getData().value1;
          } else {
            var userStores = cb.rest.AppContext.user.userStores;
            if (userStores != null && userStores != "" && userStores.length != 0) {
              for (var i = 0; i < userStores.length; i++) {
                store_ids.push(userStores[i].store);
              }
            }
          }
          if (store_ids != null && store_ids != "" && store_ids.length != 0) {
            var proxy = cb.rest.DynamicProxy.create({
              settle: {
                url: "/bill/ref/getWarehousesFromStores",
                method: "POST"
              }
            });
            var params = {
              storeIds: store_ids,
            };
            proxy.settle(params, (err, result) => {
              if (err) {
                cb.utils.alert(err.message, 'error');
              }

              if (result === undefined || result.length == 0) {
                cb.utils.alert("没有查询到当前选择店铺的仓库！", 'error');
              } else {
                var conditionWarehouse = {
                  "isExtend": true,
                  simpleVOs: []
                };
                //门店下的仓库
                conditionWarehouse.simpleVOs.push({
                  field: 'id',
                  op: 'in',
                  value1: result
                });
                //门店仓
                conditionWarehouse.simpleVOs.push({
                  field: 'wStore',
                  op: 'eq',
                  value1: true
                });

                viewmodel.get('warehouse_name').getFromModel().setFilter(conditionWarehouse);
                promise.resolve();
              }
            });
          } else {
            cb.utils.alert("无门店权限！", 'error');
          }
          return promise;
        });

        if (null != viewmodel.get("vType") && viewmodel.get("vType") !== undefined) {
          viewmodel.get("vType").getFromModel().on('afterValueChange', function (data) {
            var newType = data.value.value;
            if (newType === -1) {
              //viewmodel.get("vType").getFromModel().setText('全部');
              viewmodel.get("vType").getFromModel().setValue(null);
            }
          });
        }



      });

      var getFirstDayOfCurrentMonth = function () {
        var firstDate = new Date();
        firstDate.setDate(1); //第一天
        return firstDate.format('yyyy-MM-dd');
      };




    }
	};
	try {
		module.exports = ST_st_storecheckquery_filterVM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckquery_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckquery_filterVM.Extend.js